
import { Component, Prop, Vue } from "vue-property-decorator";

const MODEL_CLASS = "state";

@Component
export default class UploaderState extends Vue {
  @Prop({ type: String, default: "" }) readonly icon?: string;
  @Prop({ type: String, default: "" }) readonly image?: string;
  @Prop({ type: String, default: "" }) readonly text: string;
  @Prop({ type: String, default: "" }) readonly subtext: string;
  @Prop({ type: Boolean, default: false }) readonly horizontal?: boolean;
  @Prop({ type: Boolean, default: false }) readonly border?: boolean;
  @Prop({ type: Boolean, default: false }) readonly hovering?: boolean;

  get classes() {
    const { horizontal, border, hovering } = this;

    return {
      [`${MODEL_CLASS}_horizontal`]: !!horizontal,
      [`${MODEL_CLASS}_border`]: border,
      [`${MODEL_CLASS}_hovering`]: hovering,
    };
  }

  get hasImage() {
    return this.$slots["image"];
  }

  get hasContent() {
    return this.$slots["default"];
  }
}
